import type { RaceCardMarketTemplateConfig } from '@ps/isp-web-services-types';
import React from 'react';
import { useSelector } from 'react-redux';

import type { RootState } from '@swf/core/store';
import { useMeetingMarketTemplatesWidget } from '@swf/sports/models/market-templates/meetingBased';
import type {
  MarketTemplateComponent,
  SingleMarketTemplateProps
} from '@swf/sports/types/templates';

import RaceCardList from '../../components/RaceCardList/RaceCardList';

export interface DisplayConfig {
  maxNumberOfRunners?: number;
}

const RaceCard: MarketTemplateComponent<
  SingleMarketTemplateProps & { displayConfig?: DisplayConfig }
> = ({ marketId, displayConfig, templateConfig }) => {
  const { widgetSelect } = useMeetingMarketTemplatesWidget();
  const market = useSelector((state: RootState) => widgetSelect.market(state, marketId));

  return market ? (
    <RaceCardList
      market={market}
      maxNumberOfRunners={displayConfig?.maxNumberOfRunners}
      templateConfig={templateConfig as RaceCardMarketTemplateConfig}
    />
  ) : null;
};

RaceCard.marketTemplateType = 'MEETING';

export default RaceCard;
